import { useGetActiveTab } from 'broker/pages/SubmissionWorkspacePage/components/Toolbox/useGetActiveTab';

export default function useIsToolboxOpen() {
  const activeTab = useGetActiveTab();
  return !!activeTab;
}
